/**
 * Pure helpers for hard-quota display on Usage (US-074 / US-071).
 */

export type QuotaMetricLike = {
  name: string;
  used: number;
  limit: number;
  utilization_pct: number;
  soft?: boolean;
};

export type QuotasReportLike = {
  enforced?: boolean;
  note?: string;
  metrics?: QuotaMetricLike[];
  limits?: Record<string, number>;
  counters?: Record<string, number>;
};

export function isHardQuotaEnforced(report: QuotasReportLike | null | undefined): boolean {
  return Boolean(report?.enforced);
}

export function hardQuotaBadgeLabel(report: QuotasReportLike | null | undefined): string {
  return isHardQuotaEnforced(report)
    ? "Hard limits enforced"
    : "Soft / advisory only";
}

/** Prefer metrics array; fall back to pairing limits+counters keys. */
export function quotaMetricRows(report: QuotasReportLike | null | undefined): QuotaMetricLike[] {
  if (!report) return [];
  if (Array.isArray(report.metrics) && report.metrics.length > 0) {
    return report.metrics;
  }
  const limits = report.limits ?? {};
  const counters = report.counters ?? {};
  return Object.keys(limits).map((name) => {
    const limit = Number(limits[name] ?? 0);
    const used = Number(counters[name] ?? 0);
    const utilization_pct = limit > 0 ? (used / limit) * 100 : 0;
    return { name, used, limit, utilization_pct, soft: !report.enforced };
  });
}

export function utilizationBarClass(pct: number, enforced: boolean): string {
  if (pct >= 100) return enforced ? "bg-error" : "bg-warning";
  if (pct >= 80) return "bg-warning";
  return "bg-primary";
}
